<template>
  <el-select
    style="width: 300px"
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      v-for="scale in scales"
      v-if="scale.name"
      :key="scale.id"
      :label="scale.name"
      :value="scale.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "eval-scales-select",
  props: {
    value: '',
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Шкала оценки' },
  },
  data() {
    return {
      localValue: this.value,
      scales: [],
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadScales();
    });
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    loadScales() {
      this.$api.evaluation.scaleSearch({
        only_active: true
      })
        .then(({data}) => {
          this.scales = data.scales;
        });
    },
  },
};
</script>

<style scoped>

</style>
